import makeStyles from '@mui/styles/makeStyles'
import React from 'react'
import Image1 from 'images/wholesale/001.svg'
import Container from '@mui/material/Container'
import { Link } from 'react-router-dom'
import { WHOLESALE_ROUTES } from '../../../../urls'
import _ from 'lodash'
import { Theme, useMediaQuery, useTheme } from '@mui/material'
import { Trans, useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme: Theme) => ({
  section: {
    backgroundColor: '#C6DEE7',
  },
  btn: {
    backgroundColor: '#F0AE16',
    borderRadius: '30px',
  },
  dot: {
    paddingBottom: '10%',
    width: '10%',
    maxWidth: '100%',
    maxHeight: '100%',
    backgroundColor: '#C6DEE7',
    borderRadius: '50%',
    transform: 'translateY(-50%)',
    [theme.breakpoints.down('md')]: {
      paddingBottom: '25%',
      width: '25%',
    },
  },
}))

const MainBanner: React.FC = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const theme = useTheme()
  const mdDown = useMediaQuery(theme.breakpoints.down('md'))
  const range = mdDown ? _.range(0, 4) : _.range(0, 10)
  return (
    <section className={classes.section}>
      <Container maxWidth='lg'>
        <div className='flex flex-col md:flex-row items-center w-full pt-20 md:pt-30 text-center md:text-left'>
          <h1 className='pb-20 text-5xl sm:text-6xl block md:hidden'>
            {t('wholesale.growYourBusinessSellMoreSmall', 'Grow your business, sell more and get up to 100% profit')}
          </h1>
          <div className='pb-20 w-full md:w-1/3 self-baseline order-2 md:order-1'>
            <h1 className='mb-40 text-5xl lg:text-6xl hidden md:block'>
              <Trans i18nKey='wholesale.growYourBusinessSellMoreLarge'>
                Grow your business, <br /> sell more and <br /> get up to 100% profit
              </Trans>
            </h1>
            <p className='text-lg mb-30 leading-normal'>
              {t(
                'wholesale.mainBannerDescription',
                'Our professional team creates awesome cross-stitch, embroidery, beading and diamond painting patterns that customers love - all you need to do is provide them!'
              )}
            </p>
            <Link
              className={`inline-block py-14 px-5 text-xl no-underline w-300 max-w-full text-center ${classes.btn}`}
              to={WHOLESALE_ROUTES.REGISTRATION}
            >
              {t('button.becomeAPartner', 'Become a partner')}
            </Link>
          </div>
          <div className='w-full md:w-2/3 order-1 md:order-2'>
            <img className='w-full md:max-h-600' src={Image1} alt='Image 1' draggable={false} />
          </div>
        </div>
      </Container>
      <div className='flex overflow-hidden mt-20' style={{ backgroundColor: '#F2EEEA' }}>
        {range.map(idx => (
          <div key={idx} className={classes.dot} />
        ))}
      </div>
    </section>
  )
}

export default MainBanner
